import React from 'react';

const documents = {
  lastDoc: null,
  documents: [],
  setLastDocument: doc => {},
};

export const DocumentContext = React.createContext(documents);
